import {
    MEMBER_FOLLOW_PROFILE_SUCCESS,
    MEMBER_UNFOLLOW_PROFILE_SUCCESS
} from 'reducers/member';

const GET_MEMBER_FOLLOWING_REQUEST = 'GET_MEMBER_FOLLOWING_REQUEST';
const GET_MEMBER_FOLLOWING_SUCCESS = 'GET_MEMBER_FOLLOWING_SUCCESS';
const GET_MEMBER_FOLLOWING_FAILURE = 'GET_MEMBER_FOLLOWING_FAILURE';

const initState = {
    list: null,
    totalCount: 0
};

import * as backend from 'backend-helpers/memberFollowing';

export default function memberFollowing(state = initState, action) {
    if (action.type === GET_MEMBER_FOLLOWING_SUCCESS) {
        let {list, totalCount} = action.result.data.followees;

        return {
            ...state,
            list,
            totalCount
        }
    }

    if (action.type === MEMBER_FOLLOW_PROFILE_SUCCESS) {
        if (state.list && action.user) {
            return {
                ...state,
                list: [...state.list, action.user],
                totalCount: state.totalCount+1
            }
        }
    }

    if (action.type === MEMBER_UNFOLLOW_PROFILE_SUCCESS) {
        if (state.list) {
            let newList = state.list.filter((user) => user.id !== action.id);
            if (newList.length !== state.list.length) {
                return {
                    ...state,
                    list: newList,
                    totalCount: state.totalCount - 1
                }
            }
        }
    }

    return state;
}

export function getMemberFollowing(data) {
    return {
        types: [GET_MEMBER_FOLLOWING_REQUEST, GET_MEMBER_FOLLOWING_SUCCESS, GET_MEMBER_FOLLOWING_FAILURE],
        promise: backend.getMemberFollowing(data),
        data
    }
}


// WEBPACK FOOTER //
// ./src/reducers/memberFollowing.js